import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { CommentDialogContext, CommentDialogInitialState } from ".";

export const CommentDialogStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(CommentDialogInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <CommentDialogContext.Provider value={context}>
      {children}
    </CommentDialogContext.Provider>
  );
};
